window.uSlideshowInterval = null;

$(function(){
    $('.ubso-slideshow').each(function(){
        let slideImgs = $(this).find('.slideshow-slide'),
            slideImgsCount = slideImgs.length,
            currentIndex = 0;

        slideImgs.eq(currentIndex).show();

        window.uSlideshowInterval = setInterval(showNextSlide, 5000);

        $(this).find('.slideshow-pagination .slideshow-pagination__button').click(function(event){
            let nextIndex = $(this).closest('li').index();

            clearInterval(window.uSlideshowInterval);

            slideImgs.hide();
            slideImgs.eq(nextIndex).show();

            $('.slideshow-pagination .slideshow-pagination__button').attr('data-selected', null);
            $(this).attr('data-selected', true);

            currentIndex = nextIndex;

            window.uSlideshowInterval = setInterval(showNextSlide, 5000);
        });

        function showNextSlide(){
            let nextIndex = (currentIndex + 1) % slideImgsCount;

            slideImgs.eq(currentIndex).hide();
            slideImgs.eq(nextIndex).show();

            $('.slideshow-pagination .slideshow-pagination__button').attr('data-selected', null);
            $('.slideshow-pagination .slideshow-pagination__button').eq(nextIndex).attr('data-selected', true);

            currentIndex = nextIndex;
        }
    })

  $(document).on('click', '#checkout', function(event){
      if ($(this).closest('form').find('#agree').is(':checked')) {
        $(this).submit();

        //-- Event snippet for Line conversion
        _lt('send', 'cv', {
          type: 'Conversion'
        },['70341910-ac72-440c-aee2-cb074ed256d5']);
        _lt('send', 'cv', {
          type: 'InitiateCheckout'
        },['70341910-ac72-440c-aee2-cb074ed256d5']);

      }
      else {
        alert("您需要同意服務條款,退款及隱私權政策");
        return false;
      }
    });

  if($('.shopify-section--product-template').get(0)){
    $('.options-selection__input-select').each(function(){


      if($(this).find('option').length > 1){
        const event = new Event("change", {
                view: window,
                bubbles: true,
                cancelable: true
            });

            $(this).val($(this).find('option').eq(1).val());
           $(this).trigger('change');
        $(this)[0].dispatchEvent(event);
      }
    });
  }
})
